module.exports = __webpack_public_path__ + "static/media/ammarSammourSmiling.94059e14.jpeg";